/**
 * Utility funkce pro práci s formulářovými daty
 */

/**
 * Převede prázdné stringy na undefined v objektu
 * Užitečné pro GraphQL mutations, kde chceme poslat undefined místo prázdných stringů
 *
 * @param obj - Objekt k zpracování
 * @returns Nový objekt s prázdnými stringy převedenými na undefined
 */
export function convertEmptyStringsToNull<T extends Record<string, any>>(obj: T): T {
  const processed = {} as T;

  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'string' && value.trim() === '') {
      (processed as any)[key] = null;
    } else if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
      // Rekurzivně zpracovat vnořené objekty
      (processed as any)[key] = convertEmptyStringsToNull(value);
    } else {
      (processed as any)[key] = value;
    }
  }

  return processed;
}

/**
 * Kombinuje obě funkce - převede prázdné stringy i null na undefined
 *
 * @param obj - Objekt k zpracování
 * @returns Nový objekt s prázdnými stringy a null hodnotami převedenými na undefined
 */
export function sanitizeFormData<T extends Record<string, any>>(obj: T): T {
  return convertEmptyStringsToNull(obj);
}
